<div class="container-fluid home-container">
  <!--<div class="row justify-content-center">
    <sigesid-contract-quick-stats *ngxPermissionsOnly="['operations.list_contract','operations.view_contract']" ></sigesid-contract-quick-stats>
  </div>
  <div class="row justify-content-center">
    <div class="col-12">
      <sigesid-contract-clients-stats *ngxPermissionsOnly="['operations.list_contract','operations.view_contract']" ></sigesid-contract-clients-stats>
    </div>
    <div class="col-12 col-md-6 col-lg-6">
      <sigesid-contract-near-expired-piechart *ngxPermissionsOnly="['operations.list_contract','operations.view_contract']" ></sigesid-contract-near-expired-piechart>
    </div>

    <div class="col-12 col-md-6 col-lg-6">
      <sigesid-contract-expired-piechart *ngxPermissionsOnly="['operations.list_contract','operations.view_contract']" ></sigesid-contract-expired-piechart>
    </div>
  </div>
-->
<ng-container></ng-container>
</div>
